import { ethers } from "ethers";
import CrownDexABI from "../abi/CrownDex.json";

const CROWNDEX_ADDRESS = "0x20f2238d242888e3b9fe1f7ef7e800f326e3718d";

export const getCrownDexContract = async (signer) => {
  try {
    if (!signer) {
      throw new Error("Signer is not available.");
    }
    const contract = new ethers.Contract(CROWNDEX_ADDRESS, CrownDexABI, signer);
    console.log("Connected to CrownDex contract at address:", CROWNDEX_ADDRESS);
    return contract;
  } catch (error) {
    console.error("Error connecting to CrownDex contract:", error.message);
    throw error;
  }
};

// Uživatelské funkce
export const stakeDex = async (signer, token0, token1, amount0, amount1, rangeIndex) => {
  try {
    const contract = await getCrownDexContract(signer);
    const tx = await contract.stakeDex(token0, token1, amount0, amount1, rangeIndex);
    console.log("StakeDex transaction sent:", tx.hash);
    return tx.wait();
  } catch (error) {
    console.error("Error in stakeDex:", error.message);
    throw error;
  }
};

export const unstakeDex = async (signer, tokenId) => {
  try {
    const contract = await getCrownDexContract(signer);
    const tx = await contract.unstakeDex(tokenId);
    console.log("UnstakeDex transaction sent:", tx.hash);
    return tx.wait();
  } catch (error) {
    console.error("Error in unstakeDex:", error.message);
    throw error;
  }
};

export const swap = async (signer, tokenIn, tokenOut, amountIn, minAmountOut) => {
  try {
    const contract = await getCrownDexContract(signer);
    const tx = await contract.swap(tokenIn, tokenOut, amountIn, minAmountOut);
    console.log("Swap transaction sent:", tx.hash);
    return tx.wait();
  } catch (error) {
    console.error("Error in swap:", error.message);
    throw error;
  }
};

export const swapETHForToken = async (signer, tokenOut, minAmountOut, ethAmount) => {
  try {
    const contract = await getCrownDexContract(signer);
    const tx = await contract.swapETHForToken(tokenOut, minAmountOut, { value: ethAmount });
    console.log("SwapETHForToken transaction sent:", tx.hash);
    return tx.wait();
  } catch (error) {
    console.error("Error in swapETHForToken:", error.message);
    throw error;
  }
};

export const getPositionValue = async (signer, tokenId) => {
  try {
    const contract = await getCrownDexContract(signer);
    const value = await contract.getPositionValue(tokenId);
    console.log("Position value for tokenId", tokenId, ":", value);
    return value;
  } catch (error) {
    console.error("Error in getPositionValue:", error.message);
    throw error;
  }
};

export const getSwapFeeRate = async (signer) => {
  try {
    const contract = await getCrownDexContract(signer);
    const feeRate = await contract.swapFeeRate();
    console.log("Swap fee rate:", feeRate);
    return feeRate;
  } catch (error) {
    console.error("Error in getSwapFeeRate:", error.message);
    throw error;
  }
};

export const getBlacklistedAddresses = async (signer) => {
  try {
    const contract = await getCrownDexContract(signer);
    const addresses = await contract.getBlacklistedAddresses();
    console.log("Blacklisted addresses:", addresses);
    return addresses;
  } catch (error) {
    console.error("Error in getBlacklistedAddresses:", error.message);
    throw error;
  }
};